import { Component } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { GoogleAnalyticsEventsService } from "../Services/google-analytics";
import { Brand } from '../Models/brand';
import { ProductListComponent } from './product.list';
import { BrandService } from '../Services/brand';
import { MetaService } from '../Services/meta';
import { ProductService } from '../Services/product';
import { ProductFilter } from '../Models/filter';


@Component({
  selector: 'brand-detail',
  templateUrl: '../Templates/product.list.html'
})

export class BrandDetailComponent extends ProductListComponent {

  brand: Brand;
  id: number;

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              public productService: ProductService,
              protected location: Location,
              protected gaEventsService: GoogleAnalyticsEventsService,
              private meta: MetaService,
              private brandService: BrandService) {
    super(route, router, productService, location, gaEventsService);
  }

  ngOnInit() {

    this.filter = new ProductFilter();

    this.route.params.subscribe(params => {

      // filter out escaped spaces if need be
      var name = decodeURIComponent(params['name']);

      this.brandService.list(name).subscribe(
        data => {

          if (data.results.length) {
            this.brand = data.results[0];

            this.meta.setDescription(this.brand.description);

            this.meta.setTitle(this.brand.name)

            this.filter.setval('brand', this.brand.id);

            this.getProducts();
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/brand.detail.ts